import React from "react";

import { PkgIcon, CreditIcon } from "../CustomIcon";
import NavUI from "./NavUI";

import "../../styles/Guide.css";

const pages = [
  {
    key: "setting",
    pathname: "/mypage/setting",
    icon: "user",
    title: {
      id: "Mypage.nav.setting",
      text: "Setting",
    },
  },
  {
    key: "mypackage",
    pathname: "/mypage/mypackage",
    icon: <PkgIcon style={{ width: 18 }} />,
    title: {
      id: "Mypage.nav.myPackage",
      text: "My Package",
    },
  },
  {
    key:'packages-of-reviewed',
    pathname:'/mypage/packages-of-reviewed',
    icon: 'file-search',
    title:{
      id:'Upload.packages.nav.packagesOfReviewed',
      text:'Approval Status'
    }
  },
  {
    key: "remittance-info",
    pathname: "/mypage/remittance-info",
    icon: <CreditIcon />,
    title: {
      id: "Mypage.nav.remittance-info",
      text: "Remittance Info",
    },
  },
  {
    key: "remittance-request",
    pathname: "/mypage/remittance-request",
    icon: "credit-card",
    title: {
      id: "Mypage.nav.remittance-request",
      text: "Remittance Request",
    },
  }
];

const MypageNav = (props) => {
  return <NavUI selectedKey={props.selectedKey} pages={pages} />;
};

export default MypageNav;
